/*
  PANCHEEWA — mark sold-out variant options (product pages).

  Display only: adds .pncw-soldout to option inputs whose combination with
  the options chosen before them has no available variant. Inputs stay
  selectable, so Shopify's own variant logic, sold-out button state and
  cart behaviour are unchanged. Re-runs whenever the selection changes.
*/
(function () {
  function update(picker) {
    var data = picker.querySelector('script[type="application/json"]');
    if (!data) return;
    var variants;
    try {
      variants = JSON.parse(data.textContent);
    } catch (e) {
      return;
    }

    var fieldsets = picker.querySelectorAll('fieldset');
    var selected = Array.prototype.map.call(fieldsets, function (fs) {
      var checked = fs.querySelector('input:checked');
      return checked ? checked.value : null;
    });

    fieldsets.forEach(function (fs, index) {
      fs.querySelectorAll('input[type="radio"]').forEach(function (input) {
        var available = variants.some(function (variant) {
          if (!variant.available || variant.options[index] !== input.value) return false;
          for (var i = 0; i < index; i++) {
            if (variant.options[i] !== selected[i]) return false;
          }
          return true;
        });
        input.classList.toggle('pncw-soldout', !available);
        var label = fs.querySelector('label[for="' + input.id + '"]');
        if (label) {
          var hint = label.querySelector('.pncw-soldout-hint');
          if (!available && !hint) {
            hint = document.createElement('span');
            hint.className = 'visually-hidden pncw-soldout-hint';
            hint.textContent = ' (sold out)';
            label.appendChild(hint);
          } else if (available && hint) {
            hint.remove();
          }
        }
      });
    });
  }

  function init() {
    document.querySelectorAll('variant-radios').forEach(function (picker) {
      update(picker);
      picker.addEventListener('change', function () {
        update(picker);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
